export default __webpack_public_path__ + "static/media/share.419adc72.svg";